/**
 * Press Box → Season. 2026-10-17. Record, scoring leaders and goalies for the
 * season, from every game's official (or hand-entered) stats. Real names —
 * this is the signed-in view; the public page shows what the coach chose.
 */
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../services/api.js';
import { useAuth } from '../../context/AuthContext.jsx';
import PressBoxShell from './PressBoxShell.jsx';
import { StatTable, SKATER_COLS, GOALIE_COLS } from '../../components/stats/StatTable.jsx';

export default function PressBoxSeasonPage() {
  const { teamId } = useParams();
  const { user } = useAuth();
  const [season, setSeason] = useState('');
  const [data, setData] = useState(null);
  useEffect(() => {
    let c = false;
    api.get(`/teams/${teamId}/press-box/season`, { params: season ? { season } : {} })
      .then(({ data: d }) => { if (!c) setData(d); })
      .catch((e) => { if (!c) setData({ error: e.response?.data?.error || 'Could not load the season' }); });
    return () => { c = true; };
  }, [teamId, season]);

  return (
    <PressBoxShell teamId={teamId} userId={user?.id} right={data?.seasons?.length > 0 && (
      <select className="input-field" style={{ width: 'auto', padding: '8px 12px' }} value={season || data.seasonId || 'all'} onChange={(e) => setSeason(e.target.value)} aria-label="Season">
        {data.seasons.map(s => <option key={s.id} value={s.id}>{s.name}{s.active ? ' (current)' : ''}</option>)}
        <option value="all">All seasons</option>
      </select>
    )}>
      {!data && <div className="text-secondary text-sm p-4">Loading…</div>}
      {data?.error && <div className="card text-center p-4">{data.error}</div>}
      {data && !data.error && (
        <>
          <div className="card mb-4 flex items-baseline gap-6" style={{ flexWrap: 'wrap' }}>
            <div><div className="label">Record (W–L–T)</div><div className="display-num" style={{ fontSize: 30 }}>{data.record.w}–{data.record.l}–{data.record.t}</div></div>
            <div><div className="label">Goals for</div><div className="display-num" style={{ fontSize: 30, color: 'var(--goal)' }}>{data.record.gf}</div></div>
            <div><div className="label">Goals against</div><div className="display-num" style={{ fontSize: 30, color: 'var(--penalty)' }}>{data.record.ga}</div></div>
          </div>
          <div className="card mb-4">
            <div className="font-bold text-sm mb-2">Scoring</div>
            <StatTable cols={SKATER_COLS} rows={data.skaters || []} empty="No stats yet this season." />
          </div>
          <div className="card mb-4">
            <div className="font-bold text-sm mb-2">Goalies</div>
            <StatTable cols={GOALIE_COLS} rows={data.goalies || []} empty="No goalie stats yet." />
            <div className="text-xs mt-2" style={{ color: 'var(--text-3)' }}>Saves count only when the narrator calls them.</div>
          </div>
        </>
      )}
    </PressBoxShell>
  );
}
